import * as React from "react";
import type { SVGProps } from "react";
const SvgBarChart05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 21.6v-2.133M15.2 21.6v-7.467M8.8 21.6V8.8M2.4 21.6V2.4"
    />
  </svg>
);
export default SvgBarChart05;
